<template>
  <div class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 v-if="isEdit" class="mb-0">Edit Installment Plan</h1>
              <h1 v-else class="mb-0">Installment Plan Setup</h1>
              <button
                  @click="onClickClose"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>

        <hr class="mt-0 mb-0">

        <div class="pb-2">
          <div class="row mx-2">
            <div class="col-12 mb-1">
              <label for="colFormLabel" >Select Project</label>
              <v-select
                  placeholder="Select Project"
                  :options="projects"
                  label="name"
                  :reduce="name => name.id"
                  v-model="projectId"
                  :disabled="isEdit"
                  @option:selected="onSelectProject"
              />
            </div>
            <div class="col-12 col-md-6 mb-1">
              <label  for="colFormLabel">Total Amount</label>
              <input type="text" class="form-control" v-model="formData.total_amount">
            </div>
            <div class="col-12 col-md-6 mb-1">
            <label class="align-middle">Booking Amount</label>
              <input type="text" class="form-control" v-model="formData.booking_money">
            </div>
            <div class="col-12 col-md-6 mb-1">
            <label class="align-middle">Down Payment</label>
              <input type="text" class="form-control" v-model="formData.down_payment">
            </div>
            <div class="col-12 col-md-6 mb-1">
            <label class="align-middle">Remaining Amount</label>
              <input type="text" class="form-control" readonly v-model="remainingAmount">
            </div>
            <div class="col-12 col-md-6 mb-1">
            <label class="align-middle">Number Of Installment</label>
              <input type="text" class="form-control" v-model="formData.number_of_installment">
            </div>
            <div class="col-12 col-md-6 mb-1">
            <label class="align-middle">Installment Amount</label>
              <input type="text" class="form-control" readonly v-model="installmentAmount">
            </div>
            <div class="col-12 col-md-6 mb-1">
            <label class="align-middle">Installment Frequency</label>
              <v-select
                  placeholder="Select Installment Frequency"
                  v-model="formData.installment_frequency"
                  :options="intervals"
                  label="name"
                  :reduce="name => name.id"
              />
            </div>
            <div class="col-12 col-md-6 mb-1">
              <label class="align-middle">Start Date</label>
              <input type="date" class="form-control" v-model="formData.start_date">
            </div>
            <div class="col-12 text-center mb-2 mt-2">
              <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loader"/>

  </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {computed, inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import useDate from '@/services/utils/day'
import handleProjects from "@/services/modules/procurement/project";
import handleInventory from "@/services/modules/inventory";

let formData = ref({
  total_amount: null,
  booking_money: null,
  down_payment: null,
  number_of_installment: null,
  interest_amount: null,
  installment_frequency: null,
  start_date: null,
})

const props = defineProps({
  contact: Object,
  master: { type: Object, default: null }
})

const emit = defineEmits(['close', 'getData']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const isEdit = computed(() => props.master !== null);
const loader = ref(false);
const homeContent = ref({});
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { formatDateTime, formatToDate } = useDate()
const projects = ref([]);
const projectId = ref(null);

const { fetchProjects, fetchProjectForm, createProjectInstallmentSetup, updateProjectInstallmentSetup } = handleProjects();
let { fetchHome } = handleInventory();

const submit = async() => {
  const query = getQuery();
  loading.value = true;
  if (isEdit.value) return await updateData(query)
  await storeData(query)
}

const storeData = async (query) => {
  let installmentSetupData = {};
  installmentSetupData.company_id = $route.params.companyId;
  installmentSetupData.project_master_id = projectId.value;
  installmentSetupData.contact_profile_id = props.contact.id;
  installmentSetupData.billing_type = 'installment';
  installmentSetupData.total_amount = formData.value.total_amount;
  installmentSetupData.booking_money = formData.value.booking_money;
  installmentSetupData.down_payment = formData.value.down_payment;
  installmentSetupData.down_payment = formData.value.down_payment;
  installmentSetupData.interest_amount = formData.value.interest_amount;
  installmentSetupData.number_of_installment = formData.value.number_of_installment;
  installmentSetupData.installment_frequency = formData.value.installment_frequency;
  installmentSetupData.start_date = formData.value.start_date;

  await createProjectInstallmentSetup(query, installmentSetupData).then((res) => {
    if (!res.status) return showError(res.message)
    emit('getData')
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const updateData = async (query) => {
  const payload = {
    company_id: $route.params.companyId,
    total_amount: formData.value.total_amount,
    booking_money: formData.value.booking_money,
    down_payment: formData.value.down_payment,
    interest_amount: formData.value.interest_amount,
    number_of_installment: formData.value.number_of_installment,
    installment_frequency: formData.value.installment_frequency,
    start_date: formData.value.start_date,
  }
  try {
    const res = await updateProjectInstallmentSetup(props.master.id, query, payload)
    if (!res.status) {
      showError(res.message)
      return
    }
    emit('getData')
    onClickClose()
    showSuccess(res.message)
  } catch (err) {
    showError('Something is wrong. Check your connectivity!!')
  } finally {
    loading.value = false
  }
}

const fillFromMaster = () => {
  projectId.value = props.master.project_master_id
  formData.value.total_amount = props.master.total_amount
  formData.value.booking_money = props.master.booking_money
  formData.value.down_payment = props.master.down_payment
  formData.value.interest_amount = props.master.interest_amount
  formData.value.number_of_installment = props.master.number_of_installment
  formData.value.installment_frequency = props.master.installment_frequency
  formData.value.start_date = props.master.start_date
}

const remainingAmount = computed(() => {
  const total = formData.value.total_amount || 0
  const booking = formData.value.booking_money || 0
  const down = formData.value.down_payment || 0

  const remaining = total - booking - down
  return remaining > 0 ? remaining : 0
})

const installmentAmount = computed(() => {
  const count = formData.value.number_of_installment || 0

  if (count > 0) {
    return (remainingAmount.value / count).toFixed(2)
  }

  return 0
})

const intervals = computed(() => {
  let intervals = [];
  if(homeContent.value.hasOwnProperty('project_intervals')) {
    Object.keys(homeContent.value.project_intervals).forEach( id => {
      intervals.push({
        id: id,
        name: homeContent.value.project_intervals[id],
      })
    })
  }
  return intervals;
})

const onSelectProject = () => {
  const query = `?company_id=${$route.params.companyId}`;
  loader.value = true;
  resetForm()
  fetchProjectForm(projectId.value, query)
      .then( res => {
        if (res.data.project_revenue_installment){
          let installmentAmount = res.data.project_revenue_installment;
          formData.value.total_amount = installmentAmount.total_amount || 0;
          formData.value.booking_money = installmentAmount.booking_money || 0;
          formData.value.down_payment = installmentAmount.down_payment || 0;
          formData.value.number_of_installment = installmentAmount.number_of_installment || 0;
          formData.value.installment_frequency = installmentAmount.installment_frequency || 0;
        }
      })
      .catch( err => {
        showError(err.response.message);
      })
      .finally( () => loader.value = false)
}

function resetForm() {
  formData.value.total_amount = null;
  formData.value.booking_money = null;
  formData.value.down_payment = null;
  formData.value.number_of_installment = null;
  formData.value.installment_frequency = null;
}

onMounted( () => {
  const query = `?company_id=${$route.params.companyId}&status=active`;
  loader.value = true;
  const homeRes = fetchHome();
  formData.value.start_date = new Date().toISOString().split('T')[0];

  Promise.all([
    fetchProjects(query).then( res => {
      if (!res.status) return;
      projects.value = res.data;
      if (isEdit.value) return fillFromMaster();
      projectId.value = res.data[0].id
      onSelectProject()
    }),
    homeRes.then(res => {
      if (res.data) {
        homeContent.value = res.data;
      }
    }),
  ])
      .then ( () => loader.value = false)
      .catch( (err) => {
        loader.value = false
        showError( err.response.message )
      })
      .finally( () => loader.value = false)
})

const onClickClose = () => {
  emit('close')
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

</script>
